import type { ReactNode } from 'react';

/**
 * What a list says when it has nothing in it. The inbox list used to render
 * literally nothing, so the section looked broken rather than empty.
 */
export function EmptyState({
  children,
  action,
}: {
  children: ReactNode;
  action?: ReactNode | undefined;
}) {
  return (
    <div className="ui-empty">
      <p>{children}</p>
      {action}
    </div>
  );
}
